// // InsideFlashFluency/BlogPostPage.js
// import React from 'react';
// import { useParams } from 'react-router-dom';

// // Import your individual blog posts and their metadata
// import IntroducingPlusOneSRS, { post as plusOneMeta } from './BlogPosts/IntroducingPlusOneSRS';
// // If you have additional posts, import them similarly

// // Create an array of all your posts
// const allPosts = [
//   {
//     meta: plusOneMeta,
//     Component: IntroducingPlusOneSRS,
//   },
//   // { meta: otherPostMeta, Component: OtherPostComponent },
// ];

// export default function BlogPostPage() {
//   const { slug } = useParams();

//   // Find the post that matches the URL slug
//   const matchedPost = allPosts.find((p) => p.meta.slug === slug);

//   if (!matchedPost) {
//     return (
//       <div className="container mx-auto p-6">
//         <h1 className="text-3xl font-bold mb-2">Post Not Found</h1>
//         <p className="text-gray-700">We couldn't find a blog post with that slug.</p>
//       </div>
//     );
//   }

//   // Render the matched post's component
//   const PostComponent = matchedPost.Component;
//   return <PostComponent />;
// }




import React from 'react';
import { useParams } from 'react-router-dom';
import { getPalette } from '../ColorPalette';
import backdropImage from '../images/BackdropNight.png';

// Import your individual blog posts and their metadata
import IntroducingPlusOneSRS, { post as plusOneMeta } from './BlogPosts/IntroducingPlusOneSRS';
// If you have additional posts, import them similarly

// Create an array of all your posts
const allPosts = [
  {
    meta: plusOneMeta,
    Component: IntroducingPlusOneSRS,
  },
  // { meta: otherPostMeta, Component: OtherPostComponent },
];

export default function BlogPostPage() {
  const colors = getPalette('dark');
  const { slug } = useParams();

  // Find the post that matches the URL slug
  const matchedPost = allPosts.find((p) => p.meta.slug === slug);

  if (!matchedPost) {
    return (
      <div
        style={{
          minHeight: '100vh',
          backgroundImage: `url(${backdropImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          backgroundColor: colors.background,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px 24px'
        }}
      >
        <div
          style={{
            backgroundColor: colors.container,
            borderRadius: '16px',
            boxShadow: `0 4px 16px ${colors.shadow}`,
            padding: '32px',
            maxWidth: '600px',
            border: `1px solid ${colors.borderSilver}`,
            textAlign: 'center'
          }}
        >
          <h1
            style={{
              fontSize: '32px',
              fontWeight: '800',
              marginBottom: '12px',
              color: colors.text
            }}
          >
            Post Not Found
          </h1>
          <p
            style={{
              color: colors.text,
              opacity: 0.85,
              fontSize: '16px'
            }}
          >
            We couldn't find a blog post with that slug.
          </p>
        </div>
      </div>
    );
  }

  // Render the matched post's component
  const PostComponent = matchedPost.Component;
  return <PostComponent />;
}